/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate, useLocation} from 'react-router-dom'
import {ErrorPage} from './pages/error/ErrorPage'
import { PublicLayout } from './layouts/PublicLayout'
import {AuthPage} from './pages/auth'
import {useAuth} from './context/auth'
import {APIAccessPage} from './pages/api_access/APIAccessPage'
import {App} from './App'
import { ComingSoon } from './pages/info/ComingSoon'
import TermsOfService from './pages/info/TermsOfService'
import PrivacyPolicy from './pages/info/PrivacyPolicy'
import AccountDeletePage from './pages/account_delete/AccountDeletePage'
import {UnderMaintenance  } from './pages/info/UnderMaintenance'
import GuestPage from './pages/guest/GuestPage'
import { useEffect, useState } from "react";

import ChatPage from './pages/chat/ChatPage'
import AdminPage from './pages/admin/AdminPage'
import { adminAPI } from './api';

import {setTitle} from './utils'


const {PUBLIC_URL} = process.env


const AdminRoute = () => {
  const {currentUser, setCurrentUser} = useAuth()

  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    if( currentUser ){
      const checkPermission = async () => {
        try {
          const response = await adminAPI.hasPermission()
          if ( response['data']['data'] && response['data']['data']['admin_type'] ) {
            currentUser.type = response['data']['data']['admin_type']
            setCurrentUser(currentUser)
            setIsAuthorized(true)
          }else{
            setIsAuthorized(false)
          }
        } catch (error) {
          setIsAuthorized(false)
        }
      }
      checkPermission()
    }else{
      setIsAuthorized(false)
    }
  }, [currentUser])

  if (isAuthorized === null) {
    return <></>;
  }

  return isAuthorized ? <AdminPage/> : <Navigate to="/" />;
};
const AppRoutes: FC = () => {
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <InnerAppRoutes />
    </BrowserRouter>
  );
};

const InnerAppRoutes: FC = () => {
  
  const { currentUser } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname != '/c' && !pathname.startsWith('/c/') && pathname != '/s' && !pathname.startsWith('/s/')) {
      setTitle('')
    }
  }, [pathname]);
  
  return (
    <Routes>
      <Route path="/" element={<App />}>
        <Route path='a/*' element={<AuthPage />}/>
        <Route element={<PublicLayout/>}>
          <Route path='error/*' element={<ErrorPage />} />
          <Route path="coming-soon" element={<ComingSoon/>}/>
          <Route path="terms-of-service" element={<TermsOfService/>}/>
          <Route path="privacy-policy" element={<PrivacyPolicy/>}/>
          <Route path="under-maintenance" element={<UnderMaintenance/>}/>
          <Route path="api-access/request/*" element={<APIAccessPage/>}/>
          <Route path="delete-account" element={!currentUser || !currentUser.email ? <Navigate to="/a/sign-in" state={{'accountDelete':true}}/> : <AccountDeletePage />} />
        </Route>
        <Route path='c/*' element={currentUser && currentUser.email ? <ChatPage /> : <Navigate to="/"/>} />
        <Route path='s/*' element={<ChatPage />} />
        <Route path='admin/*' element={<AdminRoute />} />
        <Route path="*" element={<Navigate to="/error/404" />} />
        <Route index element={currentUser === undefined || !currentUser.email ? <GuestPage /> : <Navigate to="/c"/>} />
      </Route>
    </Routes>
  )
}

export {AppRoutes}
